const AUTO_FINALIZE_KEY_PREFIX = "fast_track_auto_finalized:";

/**
 * claimAutoFinalize reports whether the fast-track page should start the payment by itself: only
 * when the server granted it, and only once per checkout session in this tab, so a controller
 * re-mount (Turbo restore, back/forward) can never start a second payment. Any storage failure
 * keeps the manual button.
 */
export function claimAutoFinalize(granted, storage, sessionId) {
  if (!granted || !sessionId) return false;
  const key = AUTO_FINALIZE_KEY_PREFIX + sessionId;
  try {
    if (storage.getItem(key)) return false;
    storage.setItem(key, "1");
  } catch {
    return false;
  }
  return true;
}
